// extracted by mini-css-extract-plugin
export var measureBox = "_df-0";